import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { TokenTeacher } from "../TeacherApp/TeacherApp.component";
import { jwtDecode } from "jwt-decode";
import { LogInTeacher } from "../LogInTeacher/LogInTeacher";
import { AuthTeacherProps } from "./AuthTeacher.model";

const AuthTeacher = (props: AuthTeacherProps) => {
  const { token, updateToken } = useContext(TokenTeacher);

  const evaluateToken = useCallback((token: string | null) => {
    try {
      if (token === null) {
        throw new Error("Token is undefined");
      } else {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        if (typeof decoded.exp === "undefined") {
          throw new Error("Expiration is undefined");
        } else {
          return decoded.exp > currentTime;
        }
      }
    } catch (err) {
      localStorage.removeItem("token");
      return false;
    }
  }, []);

  const [isTokenValid, setIsTokenValid] = useState<boolean>(
    evaluateToken(token)
  );

  useEffect(() => {
    const id = setInterval(() => {
      let isValid = evaluateToken(token);
      setIsTokenValid(isValid);
    }, 1000);
    return () => {
      clearInterval(id);
    }
  }, [evaluateToken, token, updateToken]);

  return <>{isTokenValid ? props.children : <LogInTeacher />}</>;
};

export { AuthTeacher };
